<template>
  <div class="accordion mb-4 outer" @keydown.enter.stop.prevent="()=>{}">
    <div class="accordion-item border-component" style="height: fit-content">
      <div tabindex="0" @keydown.space.stop.prevent="clickHandler" class="accordion-header p-4 cursor-pointer" @click="clickHandler">
        <div role="button" class="titleContainer" :class="{opened: isOpen, }">
          <i class="me-4">
            <svg width="12" height="10" color="red"><use href="/sprite.svg#chevron-down"/></svg>
          </i>
          <label class="cursor-pointer">
            <div class="title fs-md-16 fs-lg-18 user-select-none" v-html="sectionName"></div>
          </label>
          <span class="ms-auto" @click.stop.prevent="deleteClick" :class="{'d-none': !isOpen, }">
            <icon name="trash" container="i-16" role="button"/>
          </span>
        </div>
      </div>
      <div class="accordion-body body-container" :class="{opened: isOpen, }">
        <hr class="horizontal-rule" v-if="isOpen"/>
        <div v-for="(item, idx) in displayQuestions" :key="idx">
          <template v-if="item.status === 'HIDDEN'"/>
          <Question
              :isAccordion="true"
              :key="idx"
              v-else-if="!HARD_CODED_ADDRESS_GROUPING[item.name] && !DYNAMIC_ADDRESS_GROUPING(item.name)"
              :disableConfirm="true"
              :onlyShowPrompt="true"
              :hideSubText="disableHelp"
              :fields="this.fields"
              :forcePromptPlaceholder="forcePromptPlaceholder"
              :class="{unanswered: !fieldValues[item.name] || fieldErrors[item.name], opa:isOpen , 'd-none':!isOpen}"
              :loadingRules="loadingRules"
              :runningRulesFor="runningRulesFor === item.name"
              :hasBeenInteractedWith="fieldsInteractedWith[item.name]"
              :skipEagerValidation="!enableEagerValidation && (disableEagerValidation || skipEagerValidation)"
              @address-change="$emit('address-change', $event)"
              @field-change="$emit('field-change', $event)"
              @field-error="$emit('field-error', $event)"
              @user-interaction="$emit('user-interaction', $event)"
              :question="item"></Question>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Question from "@/components/waffle/components/Question.vue";

export default {
  name: 'AccordionContainer',
  components: {Question},
  props: [
    'sectionName',
    'fields',
    'HARD_CODED_ADDRESS_GROUPING',
    'DYNAMIC_ADDRESS_GROUPING',
    'fieldValues',
    'fieldErrors',
    'skipEagerValidation',
    'loadingRules',
    'forcePromptPlaceholder',
    'disableHelp',
    'sectionDisplayMap',
    'disablePrompt',
    'disableEagerValidation',
    'idx',
    'fieldsInteractedWith',
    'runningRulesFor',
    'isOpenDefault',
    'enableEagerValidation'
  ],
  emits: ['delete', 'field-error', 'field-change', 'address-change','user-interaction','manually-open'],
  data() {
    return {
      isOpen: this.isOpenDefault
    }
  },
  watch:{
    isOpenDefault(next, prev){
      if(next !== prev && !next){
        this.isOpen = false;
      }
    },
  },
  computed:{
    displayQuestions(){
      return this.fields.map(item =>  item.value ? item:(this.fieldValues[item.name] ? {...item, value:this.fieldValues[item.name]}:item))
    }
  },
  methods: {
    clickHandler() {
      this.isOpen = !this.isOpen
      this.$emit('manually-open', this.isOpen ? this.displayQuestions[0]?.section:null)
    },
    deleteClick() {
      this.$emit('delete')
    }
  }
}
</script>

<style scoped>
.title {
  font-weight: bold;
  margin-bottom: 4px;
  color: #212121;
}

i.arrow {
  content: "";
  position: relative;
  display: block;
  width: 10px;
  height: 10px;
  border-style: solid !important;
  border-width: 0 3px 3px 0 !important;
  margin-right: 16px;
  color: #525252;
  transform: rotate(45deg);
  transition: 0.26s all ease;
}

.titleContainer {
  display: flex;
  align-items: center;
}

div.titleContainer.opened > i.arrow {
  transform: rotate(225deg);
}

.horizontal-rule {
  width: calc(100% - 32px);
  margin: 0px 12px 16px;
  align-self: center;
}

.body-container {
  padding: 0;
  height: auto;
  max-height: 0;
  /*overflow-y: hidden;*/
  /*transition: max-height 2s linear;*/
}

.body-container.opened {
  max-height: 20000px;
  padding: 0px 16px;
}

.body-container.opened .opa {
  opacity: 1;
  height: auto;
}

.opa {
  opacity: 0;
  height: 0;
  transition: all .75s;
}

.outer {
  //padding: 0 12px
}
</style><style>
/*TODO syam Forced overrides until we upgrade component css to Bootstrap (pending creative comps)*/
.accordion-body .quill-question {
  margin: 0 !important
}


.accordion-body .quill-question > label > span {
  font-weight: normal !important;
  font-size: 15px !important;
}

.waffle.page-context .quill-question.unanswered {
  opacity: 1;
}

div.titleContainer.opened > i > svg {
  transform: rotate(180deg);
}

</style>